import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.locale('zh-cn')
dayjs.extend(customParseFormat)

//export const date = dayjs

//获取年纪类型 年龄段类型  1：孕期  2：0-36个月   3：36个月以上
export function getAgeType(time: string, name?: string) {
  if (!name) return 1
  const now = dayjs()
  if (dayjs(time).isAfter(now)) return 1
  const age = dayjs(time).add(3, 'year') //增加3年
  if (age.isAfter(now)) {
    return 2
  } else {
    return 3
  }
}

//获取孕期 计算怀孕多久 如果已出身 直接拿现在时间减去birthday
export function getBirthday(birthday: string) {
  const now = dayjs()
  const bd = dayjs(birthday)

  //说明已经出生
  return now.diff(bd, 'day')
}

//计算宝宝年纪
export const getBirthSlot = (date: string) => {
  const birthDay = dayjs(date)
  const nowDate = dayjs()
  const days = nowDate.diff(birthDay, 'day')
  if (days < 31) {
    return days + '天'
  } else if (days < 365) {
    return Math.trunc(days / 30) + '个月'
  } else {
    return Math.trunc(days / 365) + '岁'
  }
}

/*
  获取指定日期时间戳
  */
export function getDateTime(time: string | number) {
  if (!time) {
    return ''
  }
  if (typeof time === 'string') {
    //将字符串形式的日期转换成日期对象
    time = time.replace(/-/g, '/')
  }
  const date = new Date(time)
  return date.getTime().toString()
}

/* 获取.分隔的日期字符串 */
export function getDotDate(time: number | Date) {
  if (!time) {
    return ''
  }
  const date = new Date(time)
  const year = date.getFullYear().toString()
  const m = date.getMonth() + 1
  const month = (m < 10 ? '0' : '') + m
  const d = date.getDate()
  const day = (d < 10 ? '0' : '') + d
  return `${year}.${month}.${day}`
}

/* 获取指定时间的dayjs对象 */
export function getDayjsObj(time?: any, form?: string) {
  return dayjs(time, form)
}

/* 判断两个日期是否是同一半天内 */
export function isSameHalfDay(dayjsObj1 = dayjs(), dayjsObj2 = dayjs()) {
  const day1 = dayjsObj1.format('YYYY-MM-DD')
  const hour1 = dayjsObj1.hour()
  const day2 = dayjsObj2.format('YYYY-MM-DD')
  const hour2 = dayjsObj2.hour()
  const sameDay = day1 === day2
  const sameNoon = sameDay && ((hour1 < 12 && hour2 < 12) || (hour1 >= 12 && hour2 >= 12))
  return sameNoon
}

enum AppointType {
  TODAY, //今日
  TOMORROW, //明日
  DATE //具体某个日期
}

//判断可订哪日的票
export const getAppointDate = (reserveDate?: string, reserveTime?: string, earliestBuyDate?: number) => {
  if (typeof reserveDate === 'number') {
    reserveDate = reserveDate + ''
  }
  if (!reserveDate) {
    return ''
  }
  if (+reserveDate != AppointType.DATE && !reserveTime) {
    return ''
  }
  if (+reserveDate === AppointType.DATE && !earliestBuyDate) {
    return ''
  }
  const currentTime = dayjs()
  if (+reserveDate === AppointType.TODAY || +reserveDate === AppointType.TOMORROW) {
    const deadlineTime = dayjs(`${currentTime.year()}-${currentTime.month() + 1}-${currentTime.date()} ${reserveTime}`, 'YYYY-M-D H:mm')
    if (+reserveDate === AppointType.TODAY) {
      return currentTime.isAfter(deadlineTime) ? '可订明日' : '可订今日'
    } else {
      const afterTomorrow = currentTime.add(2, 'day')
      return currentTime.isAfter(deadlineTime) ? `可订${afterTomorrow.month() + 1}月${afterTomorrow.date()}日` : '可订明日'
    }
  }
  if (+reserveDate === AppointType.DATE) {
    const time = dayjs(earliestBuyDate)
    if (time.isSame(currentTime, 'day')) {
      return '可订今日'
    }
    const tomorrow = currentTime.add(1, 'day')
    if (time.isSame(tomorrow, 'day')) {
      return '可订明日'
    }
    if (time.isAfter(currentTime)) {
      return `最早可订${time.month() + 1}月${time.date()}日`
    }
    return ''
  }
}
